export default {
  hover: "@media (hover), (-ms-high-contrast: active), (-ms-high-contrast: none)",
};
